export const options = [
  { option: 'Dolares', name: 'Dólares', id: 3 },
  { option: 'Pesos', name: 'Pesos', id: 2 }
]
